module.exports = __webpack_public_path__ + "pic/49.1d81acfa.png";